module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail-logist/home-main-modal-detail-logist.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail-logist/home-main-modal-detail-logist.component.sass
// module chunks = main